<template>
  <div>
    <header class="header-image ken-burn-center light" data-parallax="true"
            data-natural-height="500" data-natural-width="1920" data-bleed="0"
            data-image-src="../../assets/images/header1.jpg" data-offset="0">
      <div class="container">
        <h1>SOBRE NÓS</h1>
        <h2>CONHEÇA A SKY SOLAR</h2>
      </div>
    </header>
    <main>
      <section class="section-base">
        <div class="container">
          <div class="row row-fit-lg">
            <div class="col-lg-12">
              <p align="justify">
                &nbsp;&nbsp;Somos uma família de profissionais comprometidos e apaixonados que
                aproveita nossa rica herança solar para garantir que nossos clientes e parceiros
                tenham sucesso na construção do ecossistema solar que criará um planeta movido pelo
                sol.<br><br> &nbsp;&nbsp;A Sky Solar tem como foco prover soluções para que nossos
                parceiros tenham confiança em entregar a solução completa ao consumidor final. Nossa
                matriz, localizada em Maringá-PR, conta com uma estrutura robusta para agilidade nos
                envios e atendimento atencioso, abordagem única a cada situação e ambiente, trazendo
                as mais avançadas tecnologias do mercado, com equipamentos homologados e
                certificados. Atendendo as necessidades modernas com a indispensável
                responsabilidade dos tempos atuais, a nossa missão é prover soluções em energia
                solar duradouras e confiáveis, para que nossos parceiros possam desenvolver suas
                atividades principais com autonomia e tranquilidade. Temos um compromisso com nossos
                clientes e com o meio ambiente.
              </p>
            </div>
          </div>
        </div>
      </section>
      <NossosServicos></NossosServicos>
      <MarcasParceiras></MarcasParceiras>
    </main>
  </div>
</template>

<script>
import NossosServicos from 'Homepage/common/NossosServicos.vue';
import MarcasParceiras from 'Homepage/common/MarcasParceiras.vue';

export default {
  name: 'Layout',
  components: {
    NossosServicos,
    MarcasParceiras,
  },
};
</script>

<style scoped>
header {
  height: 250px !important;
  background-image: url("../assets/images/header1.jpg");
}
header .container {
  padding-top: 50px !important;
}
header h2 {
  color: #0098da !important;
  line-height: 37px;
  text-transform: uppercase !important;
  font-weight: 700 !important;
  margin: 0 !important;
  font-size: 14px !important;
}

</style>
